import React, { useState } from "react";
import { createLinkedTodo, postComptaStageForm, finalizeComptaStage } from "./comptaStageHelpers";
import NotifyPicker from "./NotifyPicker";
import { CommentField, ReadField, SubmitBar } from "./FormFields";
import { cardCls, labelCls, inputCls } from "./formStyles";

// Étape 3/5 — tache.type "Traitement niv.2" (nommage historique un peu
// trompeur : ce type de tâche appelle bien l'endpoint /traitement1 et lit
// tache.traitement1Form, anciennement handleSubmitTR1 — conservé tel quel).
function Traitement1Stage({
  tache,
  showFormInstead,
  selectedClient,
  selectedYear,
  selectedMonth,
  refetch,
  setShowOverlay,
  allUsers,
  utilisateur,
}) {
  const [formData, setFormData] = useState({
    nbrFactureAchat: "",
    nbrFactureVente: "",
    nbrDocuments: "",
    commentaireTR1: "",
    userIds: [],
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async () => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      // Cf. TriStage : commentaire du todo systématiquement vide dans le
      // parcours normal d'origine (champ "commentaire" du formData global,
      // jamais rempli à ce stade) — reproduit fidèlement.
      const todoId = await createLinkedTodo({
        title: "Bouclage mensuel - Suivi Compta",
        selectedClient,
        userIds: [selectedClient.id_collaborateur],
        commentaire: "",
      });

      const payloadTR1 = {
        nbrFactureAchat: formData.nbrFactureAchat,
        nbrFactureVente: formData.nbrFactureVente,
        nbrDocuments: formData.nbrDocuments,
        commentaire: formData.commentaireTR1,
        assignedTo: formData.userIds.join(","),
        TodoCreate: todoId,
      };

      const tacheId = await postComptaStageForm({
        clientId: selectedClient.id,
        year: selectedYear,
        month: selectedMonth,
        stage: "traitement1",
        payload: payloadTR1,
      });

      const emailTR1Payload = {
        NomComplet: `${utilisateur.lastName} ${utilisateur.name}`,
        nbrFactureAchat: formData.nbrFactureAchat,
        nbrFactureVente: formData.nbrFactureVente,
        nbrDocuments: formData.nbrDocuments,
        commentaire: formData.commentaireTR1,
        userEmails: formData.userIds,
      };
      const clientIdTR1 = selectedClient.id;

      setLoading(false);
      setShowOverlay(false);
      setSuccess(true);
      setFormData({
        nbrFactureAchat: "",
        nbrFactureVente: "",
        nbrDocuments: "",
        commentaireTR1: "",
        userIds: [],
      });

      finalizeComptaStage({
        clientId: clientIdTR1,
        tacheId,
        emailEndpoint: "https://backend-myalfa.vercel.app/api/email-tri1",
        emailPayload: emailTR1Payload,
        prevTodoEndpoint: `https://backend-myalfa.vercel.app/api/compta/${clientIdTR1}/${selectedYear}/${selectedMonth}/tri/todo`,
        refetch,
      });
    } catch (err) {
      setError(err.message);
      setLoading(false);
      setShowOverlay(false);
    }
  };

  return (
    <>
      {showFormInstead && (
        <form
          className={cardCls}
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit(tache.id);
          }}
        >
          <p className="text-sm font-bold text-[#5C1A30]">3 / Traitement comptable niv.2</p>

          <div>
            <label className={labelCls}>Nombre de facture d'achats traitées</label>
            <input
              type="text"
              value={formData.nbrFactureAchat}
              onChange={(e) => setFormData({ ...formData, nbrFactureAchat: e.target.value })}
              className={inputCls}
            />
          </div>

          <div>
            <label className={labelCls}>Nombre de facture de ventes traitées</label>
            <input
              type="text"
              value={formData.nbrFactureVente}
              onChange={(e) => setFormData({ ...formData, nbrFactureVente: e.target.value })}
              className={inputCls}
            />
          </div>

          <div>
            <label className={labelCls}>Nombre de documents non traités</label>
            <input
              type="text"
              value={formData.nbrDocuments}
              onChange={(e) => setFormData({ ...formData, nbrDocuments: e.target.value })}
              className={inputCls}
            />
          </div>

          <CommentField
            value={formData.commentaireTR1}
            onChange={(e) => setFormData({ ...formData, commentaireTR1: e.target.value })}
          />

          <NotifyPicker allUsers={allUsers} formData={formData} setFormData={setFormData} />

          <SubmitBar loading={loading} error={error} success={success} />
        </form>
      )}

      {tache.traitement1Form && (
        <div className={cardCls}>
          <ReadField
            label="Nombre de facture d'achats traitées"
            value={tache.traitement1Form.nbrFactureAchat}
          />
          <ReadField
            label="Nombre de facture de ventes traitées"
            value={tache.traitement1Form.nbrFactureVente}
          />
          <ReadField
            label="Nombre de documents non traités"
            value={tache.traitement1Form.nbrDocuments}
          />
          <ReadField label="Commentaire" value={tache.traitement1Form.commentaire} />
        </div>
      )}
    </>
  );
}

export default Traitement1Stage;
